import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle, AlertCircle, X } from "lucide-react";

export const ToastNotification = ({ toast, setToast }) => {
  return (
    <AnimatePresence>
      {toast.show && (
        <motion.div
          initial={{ opacity: 0, x: 50, y: -20 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: 50 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          style={{
            position: "fixed",
            top: "100px",
            right: "20px",
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "14px 20px",
            borderRadius: "8px",
            color: "#fff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            minWidth: "280px",
            maxWidth: "400px",
            backgroundColor: toast.type === "success" ? "#4CAF50" : "#E53935"
          }}
        >
          {toast.type === "success" ? (
            <CheckCircle size={18} color="#fff" />
          ) : (
            <AlertCircle size={18} color="#fff" />
          )}
          <span style={{ fontSize: "14px", fontWeight: "500" }}>{toast.message}</span>
          <button
            type="button"
            onClick={() => setToast({ ...toast, show: false })}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 0,
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <X size={14} color="#fff" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const useToast = () => {
  const [toast, setToast] = React.useState({ show: false, message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
  };

  React.useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ ...toast, show: false });
      }, 3500);
      return () => clearTimeout(timer);
    }
  }, [toast.show]);

  return { toast, setToast, showToast };
};
